
import * as yup from "yup";
import { CATEGORY } from "../demandHelper";

const baseRequired = {
  requestorTadig: yup.string().when("service", (service, schema) => {
    let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
    selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
    if (selectedService === "VOLTE")
      return schema.matches(/^[a-zA-Z0-9]{5}$/, "Requestor TADIG Code must be exactly 5 characters long and contain letters and numbers only").required("Required")
    return schema
  }),
  files: yup.array().max(3).when("service", (service, schema) => {
    let selectedService =service && service[0] !== undefined ? service[0].split("-")[0] : service[0];
    selectedService =selectedService !== undefined ? selectedService.toUpperCase() : selectedService;
    if (selectedService === "VOLTE") {
      return schema
        .required("required").min(1);
    }
    return schema; 
  }),
  service: yup.string().required("Required"),
  location: yup.string().when("service", (service, schema) => {
    let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
    selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
    if (selectedService !== "VOLTE")
      return schema.required("Required")
    return schema
  }),
  country: yup.string().when("service", {
    is: (v) => !!v,
    then: (s) => s.required("Required"),
    otherwise: (s) => s.notRequired(),
  }),
};

const dnsSchema = yup.object({
  dns_number: yup.string().trim().required("Required"),
  comment: yup.string().max(1000, "Comment must be at most 1000 characters")
});

const transportSchema = yup.object({
  allocated_capacity: yup.string().required("Required"),
  comment: yup.string().max(1000, "Comment must be at most 1000 characters")
});

const sigtranSchema = yup.object({
  checkBox: yup
    .array()
    .of(yup.string())
    .min(1, "Required")
    .required("Required"),
  top_destinations: yup.string().trim().required("Required"),
  avg_monthly_msu_volumes: yup.string().trim().required("Required"),
  comment: yup.string().max(1000, "Comment must be at most 1000 characters")
});
const httpSchema = yup.object({
  category: yup
    .array()
    .of(yup.string().oneOf([
        CATEGORY.ON_NET.value,
        CATEGORY.OFF_NET.value,
      ]))
    .min(1, "Required")
    .required("Required"),
  avg_mon_trans_volume: yup.string().required("Required"),
  fiveG_Core: yup.string().required("Required"),
  fiveG_SA_domestically: yup.string().required("Required"),
  hosted_Sepp_at_vodafone: yup.string().required("Required"),
  comment: yup.string().max(1000, "Comment must be at most 1000 characters")
});

const diameterSchema = yup.object({
  avg_monthly_dtr_volumes: yup.string().trim()
    .required("Required"),
  comment: yup.string().max(1000, "Comment must be at most 1000 characters")
});

const volteSchema = yup.object({
  roamingPartnerTadigId: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z0-9]{5}$/, "Roaming Partner TADIG Code must be exactly 5 characters long and contain letters and numbers only")
    .required("Required"),
  requestorCountry: yup.string().trim()
    .required("Required"),
  // requestorTadig: yup.string().trim()
  //   .required("Required"),
  requestorOrganisationName: yup.string().trim()
    .required("Required"),
  direction: yup.string().trim()
    .required("Required"),
  country: yup.string().trim()
    .required("Required"),
  roamingPartnerName: yup.string().trim()
    .required("Required"),
  connectivityServiceType: yup.string().trim()
    .required("Required"),
});

export const servicesArraySchema = yup.array().of(
  yup.lazy((row) => {
    const base = yup.object(baseRequired);

    switch (row?.service?.split('-')[0]) {
      case "DNS":
        return base.concat(dnsSchema);
      case "SIGTRAN":
        return base.concat(sigtranSchema);
      case "DIAMETER":
        return base.concat(diameterSchema);
      case "TRANSPORT":
      case "GRX" :
        return base.concat(transportSchema);
      case "VOLTE":
        return base.concat(volteSchema);
      case "HTTP2":
        return base.concat(httpSchema);
      default:
        return base;
    }
  })
);

export const formSchema = yup.object({
  organization: yup.string().required("Required"),
  info: servicesArraySchema.min(1, "At least one service is required"),
});
